<app-header
    title="University"
    subtitle=""
></app-header>



<div class="spacing-element"></div>

<div class="content-wrapper content-min-height">
    <h1 class="title">How can we help?</h1>
    <p>
        Integrated personalised online pre-arrival Induction, targeted ongoing Communication, efficient Room Inventory, Room Inspection, Fault Management, Parcels Management, Damages Management, Cleaning Management create a safe and efficient environment allowing your students to focus on their studies.
    </p>

<div style="width: 100%; height: 300px; position: relative; background-color: white; display: block;">
<div style="width: 60%; margin: auto;">
	<div style="width:250px; height:250px; border: 2px solid orange; position: absolute; left:0; margin: auto; margin-right: 50px;">
	<img src="/assets/new-images/hospitality-icon.png" style="display: block; width: 60%; margin: auto;" />
	<h3 style="font-size: 1.4rem; color: #e78104; text-align: center;">Student Communication</h3>
	</div>

	<div style="width:250px; height:250px; border: 2px solid orange; position: absolute; left: 50%;  transform: translateX(-50%); margin: auto; margin-right: 50px;">
	<img src="/assets/new-images/corporate-icon.png" style="display: block; width: 60%; margin: auto;" />
	<h3 style="font-size: 1.4rem; color: #e78104; text-align: center;">Student <br />Facilities</h3>
	</div>

	<div style="width:250px; height:250px; border: 2px solid orange; position: absolute; right: 0; margin: auto;">
	<img src="/assets/new-images/construction-icon.png" style="display: block; width: 60%; margin: auto;" />
	<h3 style="font-size: 1.4rem; color: #e78104; text-align: center;">Employee <br />Gateway</h3>
	</div>
</div>
    </div>
    
</div>

<div class="spacing-element"></div>

<div class="title-banner" id="hots">
    <h1 class="title-banner-text white">STUDENT INDUCTION</h1>
</div>
<div class="wrapper-dark">
<div class="content-wrapper" style="padding-top: 15px;" id="inspection">
    <h1 class="title inroom-title white">STUDENT INDUCTION PLATFORM</h1>

<img class="img" src="/assets/stems-images/InductionBenefits.png" style="transform: translate(25%);" />

    <p style="text-align: center;">All inductions in University corporate style with a corporate University overview where relevant. Any number or any combination can be utilised</p>
<ul style="width: 60%; margin: auto; text-align: center;">
<li>Faculty Induction</li>
<li>Student Support Services Induction (*Free inclusion of RAVI see later.)</li>
<li>International Students Induction</li>
<li>Student Union Induction</li>
<li>Library Induction</li>
<li>Health & Safety Induction</li>
<li>Equality & Diversity Induction</li>
<li>Sustainability Induction</li>
<li>Subject Induction</li>
<li>Student Studying Skills Assessment</li>
</ul>


<img class="img" src="/assets/stems-images/InductionFunctionality.png" style="transform: translate(25%);" />
</div>
</div>

<div class="title-banner" id="hots">
    <h1 class="title-banner-text white">IN<span class="green">ROOM</span></h1>
</div>
<div class="wrapper-dark">
<div class="content-wrapper" style="padding-top: 15px;" id="inspection">
    <h1 class="title inroom-title white">IN<span class="green">SPECTION</span></h1>
    <p style="text-align: center;">A programme to manage and record, area or room, condition inspections of any facilities area.</p>
    <img src="/assets/stems-images/Inspection.png" class="inroom-image" style="transform: translate(25%);" />
</div>
</div>

<div class="content-wrapper" style="padding-top: 15px;" id="inspection">
<h1 class="title inroom-title white">FIRE & MAINTENANCE INSPECTIONS</h1>
<p style="text-align: center;">Bespoke Inspections can be set up locally. Full monitoring and reporting package as with INSPECTION</p>
<p style="text-align: center;">For more information on how it can meet your needs - Contact us</p>
</div>

<div class="wrapper-dark">
    <div class="content-wrapper" style="padding-top: 15px;" id="inventory">
        <h1 class="title inroom-title white">IN<span class="green">VENTORY</span></h1>
        <p style="text-align: center;">A programme to facilitate the online completion of student Room Inventory forms by students and to manage the data generated.</p>
        <img src="/assets/stems-images/Inventory.png" class="inroom-image" style="transform: translate(25%);" />
    </div>
</div>
<div class="content-wrapper" style="padding-top: 15px;" id="invoicingDamages">
    <h1 class="title inroom-title white">IN<span class="green">VOICING DAMAGES</span></h1>
    <p style="text-align: center;">A programme for managing the whole procedure for making charges to students for damage to University property. Covering: costing repairs/replacements, communication with students, managing the appeals process in line with the University policy, allocation of costs between parties and invoicing.</p>
</div>

<div style="overflow: hidden;">
    <div class="content-wrapper" id="COVIDcleaning">
        <div class="spacing-element"></div>
        


    </div>
</div>

<div class="spacing-element"></div>



<app-footer></app-footer>